import { useContext } from 'react';
import { useStore } from 'zustand';
import { iTradingStore } from './store';
import TradingContext from './context';

type Selector<T> = (state: iTradingStore) => T;

const useTradingStore = <T>(selector: Selector<T>) => {
  const context = useContext(TradingContext);

  if (context === undefined) {
    throw new Error('useTradingStore must be used within a TradingContext');
  }

  const store = context.tradingStore;

  if (!store) {
    throw new Error('useTradingStore is not defined in TradingContextProvider');
  }

  return useStore(store, selector);
};

export default useTradingStore;
